import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["__errors"];
/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { toIdSchema } from '../../utils/idUtils';
import { shouldDisplayLabelForSchema } from '../../utils/labelUtils';
import { getSchemaType, retrieveSchema } from '../../utils/schemaUtils';
import { DEFAULT_REGISTRY, mergeObjects } from '../../utils/defaults';
import { isEmptyArrayObjectField, isCrmPropertiesField, shouldUseJsonField } from '../../utils/typeUtils';
import { ADDITIONAL_PROPERTY_FLAG } from '../../utils/schemaUtils';
import getComponentTypes from '../../constants/ComponentTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorList from '../ErrorList';
import UnsupportedField from './UnsupportedField';
import DefaultTemplate from './DefaultTemplate';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
function getFieldComponent(schema, idSchema, name, parentSchemaType) {
  const schemaType = getSchemaType(schema);
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  const componentName = getComponentTypes()[schemaType];
  if (!componentName) {
    if (schema.anyOf || schema.oneOf) {
      return () => null;
    } else {
      return () => /*#__PURE__*/_jsx(UnsupportedField
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        idSchema: idSchema,
        reason: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.errors.unknownFieldType",
          options: {
            type: schema.type || ''
          }
        }),
        type: schema.type
      });
    }
  }
  if (isCrmPropertiesField(schema, schemaType, idSchema, name) || shouldUseJsonField(schema, idSchema.$id) || isEmptyArrayObjectField(schema, schemaType, parentSchemaType)) {
    // Special case CRM object POST and PATCH properties fields, and some other object fields with many parameters
    return getComponentTypes().json;
  }
  return componentName;
}
class SchemaField extends Component {
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errorSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idPrefix,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onKeyChange,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry = DEFAULT_REGISTRY,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schemaGroup,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      parentSchemaType
    } = this.props;
    const {
      definitions,
      formContext
    } = registry;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const schema = retrieveSchema(this.props.schema, definitions, formData);
    if (Object.keys(schema).length === 0) {
      return null;
    }
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    let idSchema = this.props.idSchema;
    idSchema = mergeObjects(toIdSchema(schema, null, definitions, formData, idPrefix), idSchema);
    const shouldDisplayLabel = shouldDisplayLabelForSchema(schema, definitions);
    const readOnly = Boolean( /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    this.props.readOnly || this.props.schema.readOnly || schema.readOnly);
    const {
        __errors
      } = errorSchema,
      fieldErrorSchema = _objectWithoutPropertiesLoose(errorSchema, _excluded);
    const FieldComponent = getFieldComponent(schema, idSchema, name, parentSchemaType);
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const description = this.props.schema.description || schema.description;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const label = this.props.schema.title || schema.title || name;
    const isAdditionalProperty = schema.hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);
    const templateProps = {
      description,
      definitions,
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errors: /*#__PURE__*/_jsx(ErrorList, {
        errors: __errors
      }),
      formContext,
      id: idSchema.$id,
      label,
      onKeyChange,
      rawDescription: description,
      rawErrors: __errors,
      readOnly,
      required,
      schema,
      schemaGroup,
      shouldDisplayLabel
    };
    return /*#__PURE__*/_jsx(DefaultTemplate, Object.assign({}, templateProps, {
      children: /*#__PURE__*/_jsx(FieldComponent, Object.assign({}, this.props, {
        errorSchema: fieldErrorSchema,
        formContext: formContext,
        idSchema: idSchema,
        isAdditionalProperty: isAdditionalProperty,
        label: label,
        schema: schema,
        schemaGroup: schemaGroup,
        rawErrors: __errors,
        readOnly: readOnly,
        required: required
      }))
    }));
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
SchemaField.defaultProps = {
  autoFocus: false,
  collapsed: true,
  disabled: false,
  errorSchema: {},
  idSchema: {},
  readOnly: false
};
SchemaField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.any,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyChange: PropTypes.func,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string,
  parentSchemaType: PropTypes.string
};
export default SchemaField;